<template>
  <div class="main-wrap">
    <div id="main-content">
      <div class="wrapper">
        <div class="table-agile-info">
          <jm-crumbs/>
          <el-form>
            <div class="basic-title"><em>基本信息</em></div>
            <div class="basic-information">
              <el-form
                :model="editData"
                class="error-form basic-table basic-table-div"
              >
                <el-collapse v-model="activeNames">
                  <el-collapse-item
                    title="基本信息"
                    name="1">
                    <el-row>
                      <el-col :span="2">
                        用户名</el-col>
                      <el-col :span="8">
                        {{ editData['user_name'] }}
                      </el-col>
                      <el-col :span="2">姓名</el-col>
                      <el-col :span="5">
                        <el-input
                          v-model="editData['realname']"
                          :class="['jm-input220',]"/>
                      </el-col>
                      <el-col :span="2">昵称</el-col>
                      <el-col
                        :span="5">
                        <el-input
                          v-model="editData['nickname']"
                          :class="['jm-input220']"/>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="2">毕业院校</el-col>
                      <el-col :span="8">
                        <el-form-item prop="graduateschool">
                          <el-input
                            v-model.trim="editData['graduateschool']"
                            :class="['jm-input220',]"/>&nbsp;&nbsp;
                        </el-form-item>
                      </el-col>
                      <el-col :span="2">性别</el-col>
                      <el-col :span="5">
                        <el-select v-model="editData['sex']" placeholder="未知" class="jm-input135">
                          <el-option
                            v-for="item in sexArray"
                            :key="item.sex"
                            :label="item.label"
                            :value="item.sex">
                          </el-option>
                        </el-select>
                      </el-col>
                      <el-col :span="2">学历</el-col>
                      <el-col :span="5">
                        <el-select v-model="editData.education" placeholder="未知" class="jm-input135">
                          <el-option
                            v-for="item in educationArray"
                            :key="item.education"
                            :label="item.label"
                            :value="item.education">
                          </el-option>
                        </el-select>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="2">意向国家</el-col>
                      <el-col :span="22">
                        <el-checkbox-group
                          v-model="editData['contruy']">
                          <el-checkbox v-for="country in countrys" :label="country" :key="country">{{ country }}</el-checkbox>
                        </el-checkbox-group>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="2">出生地</el-col>
                      <el-col :span="10">
                        {{ editData['bir_addiess'] }}
                      </el-col>
                      <el-col :span="2">居住地</el-col>
                      <el-col :span="10">
                        {{ editData['addiess'] }}
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="2">来源地址</el-col>
                      <el-col :span="22">
                        {{ editData['st_source'] }}
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="2">当前地址</el-col>
                      <el-col :span="22">
                        {{ editData['laiyuan'] }}
                      </el-col>
                    </el-row>
                  </el-collapse-item>
                  <el-collapse-item
                    title="联系方式"
                    name="2">
                    <el-row>
                      <el-col :span="2">电话</el-col>
                      <el-col :span="8">
                        <el-form-item prop="crm_tel">
                          <el-input
                            v-model.trim="editData['tel']"
                            :class="['jm-input220',]"/>
                        </el-form-item>
                      </el-col>
                      <el-col :span="2">QQ</el-col>
                      <el-col :span="5">
                        <el-form-item prop="crm_qq">
                          <el-input
                            v-model.trim="editData['qq']"
                            :class="['jm-input220',]"/>
                        </el-form-item>
                      </el-col>
                      <el-col :span="2">微信</el-col>
                      <el-col :span="5">
                        <el-form-item prop="crm_weixin">
                          <el-input
                            v-model.trim="editData['weixin']"
                            :class="['jm-input220',]"/>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-row>
                      <el-col :span="2">邮箱</el-col>
                      <el-col :span="22">
                        <el-form-item prop="crm_weixin">
                          <el-input
                            v-model.trim="editData['email']"
                            :class="['jm-input220',]"/>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-collapse-item>
                </el-collapse>
              </el-form>
            </div>
            <div class="jm-primary">
              <el-button
                type="primary"
                :loading="saving"
                @click="save()">保存</el-button>
            </div>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs.vue';
import toolbar from '@/components/tool/toolbar.vue';
import tableList from '@/components/data/tableList.vue';
import { jmDictSelect } from '@/components/tool/index.js';

export default {
  data() {
    return {
      saving: false,
      countrys: ['日本', '英国', '澳洲', '其他'],
      activeNames: ['1', '2', '3', '4', '5', '6', '7', '8', '9'],
      isSnapshot: false,
      editData: {
        user_name: '',
        addiess: '',
        bir_addiess: '',
        email: '',
        laiyuan: '',
        nickname: '',
        qq: '',
        realname: '',
        graduateschool: '',
        sex: '',
        st_source: '',
        tel: '',
        weixin: '',
        education: '0',
        contruy: [], // 意向国家
      },
      sexArray: [{
        sex: 3,
        label: '未知'
      }, {
        sex: 1,
        label: '男'
      }, {
        sex: 2,
        label: '女'
      }],
      educationArray: [{
        education: '未知',
        label: '未知'
      }, {
        education: '博士',
        label: '博士'
      }, {
        education: '硕士',
        label: '硕士'
      }, {
        education: '本科',
        label: '本科'
      }, {
        education: '专科',
        label: '专科'
      }, {
        education: '中学',
        label: '中学'
      }, {
        education: '小学',
        label: '小学'
      }, {
        education: '其他',
        label: '其他'
      }],
      refresh: false,
    };
  },
  components: {
    'jm-crumbs': crumbs,
    'jm-toolbar': toolbar,
    'jm-tableList': tableList,
    jmDictSelect,
  },
  created() {
    this.$http._post({
      url: '/index/member/read',
      data: {
        id: this.$route.fullPath.split('=')[1],
      },
    }).then(({ data }) => {
      console.log(data);
      this.editData = data.members;
    });
  },
  methods: {
    // 保存数据
    save() {
      this.saving = true;
      this.$http._post({
        url: '/index/member/save',
        data: {
          editData: this.editData,
        },
      }).then(({ data }) => {
        this.saving = false;
        if (data === '修改成功') {
          this.$message.success(data);
        }
      });
    },
  },
};
</script>
<style scoped>
  td:nth-child(odd) {
    word-break: keep-all;
  }
  .basic-title {
    height: 35px;
    line-height: 35px;
    margin: 10px 8px 15px;
    position: relative;
    cursor: default;
    border-bottom: 1px solid #b8c4ce;
  }

  .basic-table {
    width: 100%;
  }
  .basic-table th {
    padding: 3px 0;
    background-color: #e2eaf0;
    border-bottom: solid 1px #b8c4ce;
    cursor: pointer;
  }
  .basic-table th span {
    margin-left: 10px;
  }
  .basic-information {
    padding: 8px;
  }
  .basic-table th i {
    font-size: 14px;
    line-height: 26px;
  }
  .basic-table th i:after {
    display: inline-block;
    margin-left: 10px;
    content: "\e608";
  }
  .basic-table .el-row .el-col {
    display: flex;
    align-items: center;
    min-height: 55px;
    padding-left: 8px;
    border-right: solid 1px #b8c4ce;
    border-bottom: solid 1px #b8c4ce;
  }
  .basic-table-info .el-row:nth-child(2) .el-col {
    font-weight: bold;
  }
  .basic-table .scores-info .el-row .el-col {
    border-right: none;
    border-bottom: none;
    padding-left: 0;
  }
  .basic-table .scores-jmte {
    padding-left: 0 !important;
    border-bottom: none !important;
    border-right: none !important;
  }
  .mindMapping a {
    text-decoration: underline;
    color: #000;
  }
</style>

<style>
  .diff_column input.el-input__inner {
    border-color: red;
  }
  .diff_column .el-select input.el-input__inner {
    border-color: red;
  }
  .basic-table-div .el-form-item__content {
    line-height: inherit !important;
  }
</style>
